(function () {
  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Math.max(0, Number(days) || 0);

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) remaining -= 1;
    }

    return result;
  }

  function renderDeliveryDates(root) {
    root.querySelectorAll('[data-levano-delivery-date]').forEach(function (element) {
      var deliveryDate = addBusinessDays(new Date(), element.dataset.businessDays);
      var locale = document.documentElement.lang || 'en';
      element.textContent = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
      }).format(deliveryDate);
    });
  }

  function updatePercentageSaving(root, variant) {
    var saving = root.querySelector('[data-levano-save-price]');
    if (!saving || !variant) return;

    if (variant.compare_at_price > variant.price) {
      var amount = variant.compare_at_price - variant.price;
      var formatted = (window.theme && theme.Currency && theme.settings)
        ? theme.Currency.formatMoney(amount, theme.settings.moneyFormat)
        : (amount / 100).toFixed(2);
      saving.innerHTML = saving.dataset.label.replace('[saved_amount]', formatted);
      saving.classList.remove('hide');
    } else {
      saving.classList.add('hide');
    }
  }

  // Urgency-Zeile: Text je Größe, Balken = Restzeit bis zur echten Frist.
  function urgencyText(bar, variant) {
    var idx = parseInt(bar.dataset.sizeIndex, 10);
    var size = (idx >= 0 && variant && variant.options) ? variant.options[idx] : '';
    var label = size ? 'Size ' + size : '';
    if (variant && !variant.available && label) {
      return bar.dataset.soldout.replace('[size]', label);
    }
    if (label) return bar.dataset.text.replace('[size]', label).replace('[date]', bar.dataset.date);
    return bar.dataset.textNosize.replace('[date]', bar.dataset.date);
  }

  function updateSizeLabels(root, variant) {
    if (!variant || !variant.options) return;
    root.querySelectorAll('[data-lv-size-label]').forEach(function (el) {
      var v = variant.options[Number(el.dataset.optionIndex)];
      if (v) el.textContent = v;
    });
  }

  // Restbestand der Variante aus data-stock (nur echter Bestand; Beispielwerte nur im Editor).
  function stockQty(bar, variant) {
    try { return Number(JSON.parse(bar.dataset.stock || '{}')[variant.id]) || 0; } catch (e) { return 0; }
  }

  function updateUrgency(root, variant) {
    var bar = root.querySelector('[data-lv-ub]');
    if (!bar || !variant) return;
    var qty = stockQty(bar, variant);
    var text = bar.querySelector('[data-lv-ub-text]');
    bar.classList.toggle('is-stock', qty > 0);
    if (qty > 0) {
      var idx = parseInt(bar.dataset.sizeIndex, 10);
      var size = (idx >= 0 && variant.options) ? 'Size ' + variant.options[idx] : '';
      text.textContent = bar.dataset.stockText.replace('[qty]', qty).replace('[size]', size);
      bar.querySelector('.lv-ub__fill').style.width = Math.max(6, Math.min(100, qty * 100 / Number(bar.dataset.stockMax || 10))) + '%';
    } else {
      text.textContent = urgencyText(bar, variant);
      tickUrgency(root);
    }
    bar.classList.toggle('is-soldout', !variant.available);
  }

  function tickUrgency(root) {
    var bar = root.querySelector('[data-lv-ub]');
    if (!bar || bar.classList.contains('is-stock')) return;
    var end = Number(bar.dataset.end) * 1000;
    var start = Number(bar.dataset.start) * 1000;
    var now = Date.now();
    if (now >= end) { bar.remove(); return; }
    var pct = Math.max(6, Math.min(100, ((end - now) / Math.max(1, end - start)) * 100));
    bar.querySelector('.lv-ub__fill').style.width = pct + '%';
  }

  function init(root) {
    if (root.dataset.levanoInitialized === 'true') return;
    root.dataset.levanoInitialized = 'true';
    renderDeliveryDates(root);
    tickUrgency(root);
    root.addEventListener('variantChange', function (event) {
      updateUrgency(root, event.detail && event.detail.variant);
      updateSizeLabels(root, event.detail && event.detail.variant);
    });
    root.addEventListener('variantPriceChange', function (event) {
      window.requestAnimationFrame(function () {
        updatePercentageSaving(root, event.detail && event.detail.variant);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-levano-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
